import React from "react";
import pic from "../image/profilePic1.jpeg";
import gitHub from "../image/github.png";
import linkedin from "../image/linkedin.png";
import resume from "../image/resume.png";

const About = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center mt-5">
        <img
          className="w-36 mb-4  transition-all"
          src={pic}
          alt="AbdulRehman"
          style={{
            borderRadius: "50%",
            filter: "drop-shadow(2px 6px 5px rgba(51, 50, 50, 0.87))",
          }}
        />
        <h1 className="text-center text-xl h-8">
          Hi, I am <span className="text-rose-700 ">AbdulRehman.</span>
        </h1>
        <h2 className="text-center h-9">
          A <span className="text-rose-700">MERN</span> stack developer
        </h2>
        <p className="text-sm text-zinc-800 px-4 box-border">
          "Welcome to the portfolio website of AbdulRehman, a talented MERN
          stack developer from Sahiwal, Pakistan. Here, you will find a
          collection of my past projects and my skills as a developer. My
          expertise includes working with MongoDB, Express.js, React.js, and
          Node.js to create fully-functional and responsive web applications. I
          have a passion for creating clean and user-friendly designs, and I
          take pride in my ability to turn complex ideas into simple, yet
          powerful solutions. My portfolio showcases a variety of projects that
          I have worked on, including e-commerce websites, social media
          platforms, and more. If you are in need of a website or have an idea
          for a web application, please feel free to contact me. I would be
          happy to discuss your project and help bring your vision to life.
          Browse through my portfolio and see my work for yourself. Thanks for
          visiting my website.".
        </p>
        <div className="space-x-2 flex justify-center items-center">
          <button className="border-2 py-1 rounded-3xl px-2 border-blue-700 hover:bg-blue-700 hover:text-white transition-all">
            <a href="https://drive.google.com/file/d/1Zp8PKpqGeVUaHEuIQGrbiP8pBH6dDgZB/view?usp=sharing">
              <img src={resume} alt="resume" className="inline-block w-7 " />{" "}
              Resume
            </a>
          </button>
          <button className="hover:translate-y-1 transition-all">
            <a href="https://github.com/ar889">
              <img src={gitHub} alt="github" />
            </a>
          </button>
          <button className="hover:translate-y-1 transition-all">
            <a href="linkedin.com/in/ar889">
              <img src={linkedin} alt="linkedin" />
            </a>
          </button>
        </div>
        <hr className="h-1 bg-slate-800 w-3/4 mt-3" />
      </div>
    </>
  );
};

export default About;
